import { render, staticRenderFns } from "./ICheck.vue?vue&type=template&id=1b2d5ccb&"
import script from "./ICheck.vue?vue&type=script&lang=ts&"
export * from "./ICheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports